// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"498":"reservations","543":"gallery","884":"admin"}[chunkId] + "." + {"498":"9116e08c","543":"d72441ae","884":"aefe9c4d"}[chunkId] + ".css";
};